import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const investmentListingsIdentity = defineEntityIdentity({
	definitionKey: "investmentListing",
	pageKey: "investmentListing",
	nameSingular: "investmentListing",
	namePlural: "investmentListings",
	relationKey: "investmentListing",
	auditKey: "investmentListings",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.investmentListings.readAll, audience: "allMembers" },
		create: { ...PERMISSIONS.investmentListings.createAll, audience: "restricted" },
		update: { ...PERMISSIONS.investmentListings.updateAll, audience: "restricted" },
		delete: { ...PERMISSIONS.investmentListings.deleteAll, audience: "restricted" }
	},
	compatibility: { backendAliases: ["investmentListings"] }
});
